import fetchWrapper from "../../../../api/fetchWrapper";
import { ENDPOINT } from "../../../../api/endpoint";

export const useExportAuditLogsData = (filters:any) => {
  const exportAuditLogsData = async () => {
    const body = {
      startDate: filters?.startDate,
      endDate: filters?.endDate
    };
    // Replace this with your actual API endpoint and logic.
    const response = await fetchWrapper(ENDPOINT.EXPORT_AUDIT_LOGS, {
      method: "POST",
      body: JSON.stringify(body),
    });

    if (response?.preSignedURL) {
      try {
        const preSignedURLResponse = await fetch(response.preSignedURL, {
          method: "GET",
          credentials: "omit",
          mode: "cors", // ✅ Ensures CORS mode is enabled
          headers: {
            Accept: "application/json", // ✅ Remove "Content-Type" if not required
          },
        });

        const json = await preSignedURLResponse.json();
        return json;
      } catch (error) {
        console.error(error);
      }
    }
    return null;
  };

  return { exportAuditLogsData };
};
